import apiClientService from "./ApiClientService";

// Setările lecțiilor practice:
// { totalLessons: 30, polygonLessons: M (pentru elevii noi), myPolygonLessons }
// myPolygonLessons = câte lecții pe poligon are elevul logat (fixat la prima
// programare; setarea nouă se aplică doar elevilor noi).

async function readOrThrow(res, fallback) {
   if (res.ok) return res.json();
   let msg = fallback;
   try {
      const err = await res.json();
      if (err?.message) msg = Array.isArray(err.message) ? err.message.join(" ") : err.message;
   } catch {}
   throw new Error(msg);
}

export async function getBookingSettings() {
   return readOrThrow(
      await apiClientService.get("/settings/booking"),
      "Nu am putut încărca setările lecțiilor.",
   );
}

/** Doar adminul. */
export async function updateBookingSettings(polygonLessons) {
   return readOrThrow(
      await apiClientService.patch("/settings/booking", {
         polygonLessons: Number(polygonLessons),
      }),
      "Nu am putut salva setarea.",
   );
}
